export default {
  hkStock: '港股',
  usStock: '美股',
  futures: '期貨',
  toDeposit: '去入金',
  quotesTitle: '實時行情',
  quotesApply: '行情申請',
  applyRecords: '申請記錄',
  domestic: '是',
  unDomestic: '否',
  quotesDomestic: '本人確認本人之所有資料與開戶時所提交的資料相同',
  quotestips: '根據Nasdaq的要求，客戶在申請使用美股實時行情時，需要提供相關信息以供審核',
  employmentSelector: {
    Employment: '就業',
    selfCare: '自僱',
    retirement: '退休',
    Unemployed: '無業'
  },

  employmentTransfor: {
    '就業': 'employed',
    '自僱': 'self',
    '退休': 'retired',
    '無業': 'unemployed'
  },
  formList: {
    employment: '就業情況',
    company: '公司名稱',
    companyAddress: '公司地址',
    industry: '行業/職業',
    occupation: '職業/職務',
    residentialAddress: '住宅地址',
    residentialAddressImg: '住址證明'
  },
  formError: {
    residentialAddress: '請輸入住宅地址',
    company: '請輸入公司名稱',
    companyAddress: '請輸入公司地址',
    industry: '請輸入行業/職業',
    occupation: '請輸入職業/職務',
    imageKeys: '請上傳住址證明',
    agreeError: '至少勾選一項',
    employmentSituationContent: '請選擇就業情況'
  },
  addressTips: {
    tips: '溫馨提示',
    line1: '1、拍照時請將證明文件平放，保持光照充足並避免反光；',
    line2: '2、請確保證明文件上的姓名、日期、住址等信息清晰可見，確保證明文件在最近三個月內；',
    line3: '3、證明文件可以是水電煤、電信、寬帶等的增值稅發票;或者經執業會計師、律師或公證人認證的信用卡對賬單、水電、煤氣、電信通知單等。 '
  },
  orderId: '訂單編號',
  accountNo: '賬號',
  applyService: '申請服務',
  updatedTime: '更新時間',
  nextStep: '下一步',
  cancelApplyTitle: '取消行情須知',
  cancelApplyData:
`1. 撤銷行情申請會於提交申請日的下一個歷月開始生效。 </br>
    如：1月15日申請撤銷，行情有效期會至該月底（即1月31日）。行情會於2月1 日起取消。 </br>
    2. 已付的月費不會退還。如：1月15日成功申請終止服務，已繳付之1月份費用不會退還。 </br>
    3. 處理申請時間需要一至兩個工作天，於該月二十五日或之前提交的申請可於該月完成撤銷；於該月二十五日後提交的申請，未必能於該月完成撤銷申請，客戶有可能需繳付下一歷月的行情月費（如有）。 </br>
    4. 撤銷行情申請後，如需重新開通，需於完成撤銷後下一歷月重新申請。 `,
  conditionTitle: '申請行情須知',
  hkFeaturesTerms: {
    title: '香港期貨即時行情條款及條件與聲明',
    subTitle: '本人確認清楚明白及簽署以同意上述有關申請網上即時報價服務之條款及細則，以及陳述。 ',
    item: `客戶確認清楚明白及簽署以同意下述有關申請香港期貨即時報價服務之條款及細則，以及下列陳述，您點擊同意、接受或下一步，或您登錄、或透過本公司進行以下交易所行情訂閱的行為均視為您已閱讀、理解並同意簽署本協議：</br></br>
    1. 費用將於申請審批後即時扣除當月費用；其後於每月25日扣除下個月的費用。 </br>
    2. 客戶必須確保期貨戶口內須有足夠資金餘額以扣除即時報價月費。本公司有權收取客戶因戶口負數衍生之利息。 </br>
    3. 為免引起任何誤解, 服務不足一個月亦作一個月計算。本公司有可能會根據交易所收費調整、本服務的整體規劃，對本服務的收費標準、方式等進行修改和變更，前述修改、變更，本公司將在相應服務頁面進行展示。您若需要獲取、使用本服務，請先提前了解清楚當時關於本服務的收費標準、方式等資訊。 </br>
    4. 客戶確認所有實時報價服務僅供個人使用，不得因任何理由而將任何資料提供予其他人士。 </br>
    5. 鑑於資料傳輸可能受各種不確定因素影響，本公司及相關機構竭力提供準確而可靠的資料，但並不保證資料絕對無誤。以上公司等概不負責任何資料錯漏、資料傳送時差或任何因依賴有關服務導致客戶獲取之實時報價而蒙受之損失。 </br>
    6. 客戶充分理解並接受：本公司對因任何原因造成的資訊異常或資訊傳遞異常情況所致後果不承擔責任。 </br>
    7. 對市場資料的產權</br>
        (a)客戶了解並且同意：(a)交易所對期貨資訊享有排他性權益；(b)未經交易所授權許可，任何單位和個人不得從事任何與交易所期貨資訊有關的資訊服務業務，包括但不限於發布、經營、增值開發或者傳播交易所期貨資訊等；(c)除本條款及條件約定外，客戶以及任何其他單位或者個人均不享有與交易所期貨資訊有關的任何權利（包括但不限於獲取、接收、儲存或者傳播期貨資訊的權利）。 </br>
        (b)客戶了解並同意：行情資料的披露，或者任何違反或威脅違反本條款及條件所包含之承諾與行為，將導致所有交易所蒙受無可挽回的、無法用賠償金彌補的巨大損失。因此，客戶進一步承認並同意：所有相關交易所有權因違反或威脅違反本條款及條件所含任何條款、要求或承諾（包括但不限於：披露或威脅披露行情資訊）的行為，在所有可得法定救濟或等價補償之外，獲得履約賠償、強制救濟及其它同等救濟。 </br>
    8. 客戶接收行情資料</br>
    本條款及條件規定了客戶接收和使用交易所行情資料的具體條款。客戶承認：儘管已經簽署了此類協議，每個交易所仍然可以憑其獨立裁量權，終止提供其行情資料，或變更或消除其資料傳輸方式、速度或信號特徵。另外，客戶承認並同意：所有交易所均保留拒絕任何客戶的權利，並且，保留根據任何理由，或在無任何理由的情況下，指示服務商終止某個客戶的行情資訊接受權的權利。在此類情況下，交易所應通知服務商此類資訊，而服務商應在現實條件允許的情況下盡快停止行情資訊的提供。 </br>
    9. 艾德保留日後更改以上計劃及服務之權利及收費，恕不另行通知。 </br>
    10. 投資於金融市場具一定風險，投資價格可升可跌。 </br>
    `
  },
  eddidPro: {
    title: '香港及環球期貨實時行情數據訂閱協議',
    subTitle: '本人確認清楚明白及簽署以同意上述有關申請網上即時報價服務之條款及細則，以及陳述。 ',
    item: `一、香港期貨即時行情條款及條件與聲明</br></br>
    客戶確認清楚明白及簽署以同意下述有關申請香港期貨即時報價服務之條款及細則，以及下列陳述，您點擊同意、接受或下一步，或您登錄、或透過本公司進行以下交易所行情訂閱的行為均視為您已閱讀、理解並同意簽署本協議：</br></br>
    1.費用將於申請審批後即時扣除當月費用；其後於每月25日扣除下個月的費用。</br>
    2.客戶必須確保期貨戶口內須有足夠資金餘額以扣除即時報價月費。本公司有權收取客戶因戶口負數衍生之利息。</br>
    3.為免引起任何誤解, 服務不足一個月亦作一個月計算。本公司有可能會根據交易所收費調整、本服務的整體規劃，對本服務的收費標準、方式等進行修改和變更，前述修改、變更，本公司將在相應服務頁面進行展示。您若需要獲取、使用本服務，請先提前瞭解清楚當時關於本服務的收費標準、方式等資訊。</br>
    4.客戶確認所有即時報價服務僅供個人使用，不得因任何理由而將任何資料提供予其他人士。</br>
    5.鑒於資料傳輸可能受各種不確定因素影響，本公司及相關機構竭力提供準確而可靠的資料，但並不保證資料絕對無誤。以上公司等概不負責任何資料錯漏、資料傳送時差或任何因依賴有關服務導致客戶獲取之即時報價而蒙受之損失。</br>
    6.客戶充分理解並接受：本公司對因任何原因造成的資訊異常或資訊傳遞異常情況所致後果不承擔責任。</br>
    7.對市場資料的產權</br>
    (a)客戶了解並且同意：(a)交易所對期貨資訊享有排他性權益；(b)未經交易所授權許可，任何單位和個人不得從事任何與交易所期貨資訊有關的資訊服務業務，包括但不限於發佈、經營、增值開發或者傳播交易所期貨資訊等；(c)除本條款及條件約定外，客戶以及任何其他單位或者個人均不享有與交易所期貨資訊有關的任何權利（包括但不限於獲取、接收、儲存或者傳播期貨資訊的權利）。</br>
    (b)客戶了解並同意：行情資料的披露，或者任何違反或威脅違反本條款及條件所包含之承諾與行為，將導致所有交易所蒙受無可挽回的、無法用賠償金彌補的巨大損失。因此，客戶進一步承認並同意：所有相關交易所有權因違反或威脅違反本條款及條件所含任何條款、要求或承諾（包括但不限於：披露或威脅披露行情資訊）的行為，在所有可得法定救濟或等價補償之外，獲得履約賠償、強制救濟及其它同等救濟。</br>
    8.客戶接收行情資料</br>
    本條款及條件規定了客戶接收和使用交易所行情資料的具體條款。客戶承認：儘管已經簽署了此類協定，每個交易所仍然可以憑其獨立裁量權，終止提供其行情資料，或變更或消除其資料傳輸方式、速度或信號特徵。另外，客戶承認並同意：所有交易所均保留拒絕任何客戶的權利，並且，保留根據任何理由，或在無任何理由的情況下，指示服務商終止某個客戶的行情資訊接受權的權利。在此類情況下，交易所應通知服務商此類資訊，而服務商應在現實條件允許的情況下儘快停止行情資訊的提供。</br>
    9.艾德保留日後更改以上計畫及服務之權利及收費，恕不另行通知。</br>
    10.投資於金融市場具一定風險，投資價格可升可跌。</br>
    11.本人確認清楚明白及簽署以同意上述有關申請網上即時報價服務之條款及細則，以及陳述。</br></br></br>

    二、環球期貨市場數據訂閱協議</br></br>

    條款及條件與聲明</br></br>
    1.投資于金融市場具一定風險，投資價格可升可跌。</br></br>
    2.客戶若欲終止以上計劃，須于一個月前以書面通知本公司，否則使用期不足一個月者，亦須繳付整月服務費用。</br></br>
    3.艾德證券期貨有限公司保留日後更改以上計劃及服務之權利及收費，恕不另行通知。</br></br>
    4.客戶確認清楚明白及同意下述附錄II: 市場數據訂閱協議。</br></br>
    5.各參與證券交易所或協會宣稱其向發布有關數據各方所提供之一切市場數據擁有專有權益。客戶 明白，概無一方擔保市場數據或任何其他市場資料之及時性、先後次序、準確性或完整性。因艾德證券期貨有限公司或任何發布數據一方之任何疏忽行動、不可抗力事件或任何發布數據一方不能合理控制之其他原因而造成之數據、資料、訊息或其傳送或交付而出現之偏差、錯誤、延誤、遺漏或干擾，艾德證券期貨有限公司或任何發布數據一方均無須負責。</br></br>
    6.艾德證券期貨有限公司，芝加哥商品交易所及相關交易所竭力提供準確而可靠的資料，但幷不保證資料絕對無誤。以上公司等概不負責任何資料錯漏、資料傳送時差或任何因依賴有關服務導致客戶獲取之實時報價而蒙受之損失。</br></br>
    7. 客戶確認所有實時報價服務僅供個人使用，不得因任何理由而將任何數據提供予其他人士。</br></br>
    8. 月費將于客戶之期貨賬戶內扣除。</br></br>
    9. 客戶必須同意本公司將有關資料提交予服務供應商或任何相關之第三方作爲身份核實之用。</br></br>
    10. 客戶必須確保期貨戶口內須有足够美金以扣除報價月費。艾德證券期貨有限公司有權收取客戶因戶口負數衍生之利息。</br></br>
    附錄 I: 非金融專業人士自我認證</br></br>
    根據用戶的資格，用戶可能會被收取較低的信息費用。被認定爲“非專業”的用戶，才可以獲得收取較低的用戶費用。</br></br>
    非專業是指幷包括任何（i）個人及自然人用戶，或者（ii）某些小型企業實體（有限責任公司，合夥企業，信托或公司），收取和使用信息（不包括任何場內交易數據） ，在每種情况下受到以下限制：</br></br>
    非專業用戶必須:</br></br>
    1) 有一個活躍的期貨交易賬戶;</br></br>
    2) 是個人，自然人或小型企業實體;</br></br>
    非專業用戶不得:</br></br>
    3) 成爲任何交易所會員（或持有或租借任何類型的會員資格）;</br></br>
    4) 注册或有資格作爲任何股票，商品或期貨交易所或合約市場，或與任何金融監管當局一個專業的交易者或投資顧問的資格;</br></br>
    5) 從事券商，銀行，投資或金融活動的機構的代表;</br></br>
    非專業用戶使用信息必須:</br></br>
    6) 是專爲用戶的個人或私人使用;</br></br>
    7) 僅限于管理用戶的自有資産，而不是以任何身份與任何第三方的任何資産的管理連接使用;</br></br>
    非專業用戶獲取資料必須只能:</br></br>
    8) 就每一發布商（數據）通過最多兩部已被獲准取得實時數據和能够送出交易指令至 CME Globex 平臺的交易終端。</br></br>
    不符合非專業用戶資格的用戶，將被認爲是專業用戶。</br></br>
    即使在本合同中的任何條款下，CME 有權在所有情况下作出最終决定，用戶是否作爲一個非專業或專業用戶的定義。 CME 保留在任何時間修改本政策或終止非專業用戶較低的費用權利。</br></br>
    有資格作爲非專業用戶應該同意及確認其非專業用戶身份幷遞交自我認證聲明回發布商。請注意，本聲明可能會受到發行商的審查和認可。若用戶不再具有作爲一個非專業用戶的資格，用戶必須在合理可行的情况下，儘快通知發布商。</br></br>
    附錄 II: 市場數據訂閱協議</br></br>

    本市場數據訂閱協議（「協議」）于 申請提交當天（「生效日期」）由艾德證券期貨有限公司與閣下訂立。本協議准許閣下根據本協議的以下條款及條件存取、收取及使用若干市場數據（定義見下文）。協議監管閣下獲取及使用市場數據，幷構成經銷商與訂閱用戶（各自爲經銷商及訂閱用戶，各自爲一「訂約方」，及統稱爲「訂約方」）之間具法律約束力的協議。</br></br>
    1. 釋義</br>
    a. 「裝置」指以可閱讀、可收聽或其他可理解的形式收取、存取或展示市場數據任何設備（固定或可携式）單位。</br></br>
    b. 「交易所」指包括但不限于CME（芝加哥商業交易所）、CBOT（芝加哥期貨交易所）、COMEX（紐約商品交易所）、NYMEX（紐約商業交易所）、ICE Futures Canada（ICE 加拿大期貨交易所）、ICE Futures、 Europe（ICE 歐洲期貨交易所）及ICE Futures US （ICE 美國洲際期貨交易所）。</br></br>
    c. 「不可抗力事件」指任何水灾、特殊天氣狀况、地震或其他天灾、火灾、戰爭、恐布活動、叛亂、騷亂、勞資糾紛、意外、政府行動、通訊或電力故障，或設備或軟件故障。</br></br>
    d. 「人士」指任何自然人、獨自經營業務、法團、合夥經營業務、有限責任公司或其他機構。</br></br>
    e. 「市場數據」指已上市及場外買賣的衍生工具合約（包括但不限于掉期及期貨）及期權合約或類似的衍生工具的資料及數據以及指數數據和分析數據。市場數據可包括但不限于開市及收市價、價格高位及低位、結算價、現時買入及賣出價、未平倉合約資料、最後賣價、限價、報價要求、固定價格、數據曲綫、估計及實際交易量數據、合約規格，以及最新或延遲訊息。就訂閱用戶在協議下的責任而言，市場數據亦包括向訂閱用戶傳送與市場數據大致相若的資料的該等資料、數據及村料。</br></br>
    f. 「買賣合約」指在上文所列的交易所買賣的合約及由交易所刊發的任何相應指數。</br></br>
    g. 「場外交易市場數據」指與場外交易衍生工具合約有關的市場數據。</br></br>
    2. 于市場數據的專有權利</br></br>
    a. 訂閱用戶表示明白及同意各交易所于及對其本身的市場數據享有專有及有價的財産權利。該等未在公開領域內出現的市場數據構成交易所享有的有價保密資料、商業秘密及/或所有權權利，幷且該等市場數據最少于直至各相關交易所將之放在公開領域或授權將其各自的市場數據放在公開領域爲止將一直爲各交易所的有價保密資料、商業秘密及/或專屬所有權權利，如非訂立本協議，訂閱用戶將無權利或不可存取該等市場數據。某一交易所是否有將其市場數據放在公開領域或授權將其市場數據公開領域，將根據該交易所與經銷商之間訂立的協議的條款厘定，該協議的描述載于第 3a 節。</br></br>
    b. 訂閱用戶表示明白及同意披露任何市場數據或任何違反或威脅違反本協議內所載的任何其他契諾或協議，將對交易所造成無法修補的傷害，金錢上的損害賠償將不足以補償。因此，訂閱用戶進一步表示明白及同意交易所將有權在現時可能享有的任何其他法律或衡平法補救以外（及不限于現時可能享有的任何其他法律或衡平法補救），就違反或威脅違反協議的任何條文、要求或契諾（包括但不限于任何披露或威脅披露市場數據）享有特定的履約及禁制命令及其他衡平法濟助。</br></br>
    3. 訂閱用戶收取市場數據</br></br>
    a. 協議載列訂閱用戶可使用市場數據的條款及條件。訂閱用戶表示明白，儘管有任何協議，各交易所可按其酌情權，停止發放市場數據或更改或取消其本身的方法、速度或訊息特點。此外，訂閱用戶表示明白及同意，經銷商或交易所保留權利，可因任何理由或在沒有理由下不批准任何訂閱用戶及終止任何訂閱用戶收取市場數據， 而在該情况下，交易所將知會經銷商，而經銷商將在實際可行的情况下儘快停止向訂閱用戶提供市場數據。</br></br>
    b. (i)除下文第3b(iii)節列明者外，訂閱用戶將只會以市場數據用于本身的內部業務活動（ 內部業務活動將不包括附屬公司及聯屬公司），及將只會在訂閱用戶不時以書面形式向經銷商指明的該等辦事處以及地點和裝置上使用。 （在緊接本文的前段內所用的「用于本身的內部業務活動」一詞，指用于訂閱用戶的(a)交易，以其本身的名義或爲其客戶本身的名義；(b)評估，爲其本身的內部業務决定；或(c)向客戶提供有關衍生工具市場的動向或趨勢的意見，但須受本分節下文有關以電話方式向客戶披露必要的市場數據及獲允許的市場數據的所有限制所規限。</br></br>
    (ii)訂閱用戶同意，除上文指定者外，其將不會以任何形式提供或以其他方式協助提供或容許提供市場數據或容許以其他方式協助提供市場數據予任何其他人士或任何辦事處或地點，亦不會容許任何其他人士直接或間接從該等辦事處或地點獲取任何市場數據，幷將會采取及執行任何政策以合理防止市場數據該等辦事處或地點被取走。訂閱用戶特別地同意，在不限制或改變其于協議的第 7 節或其他章節下的責任前提下，訂閱用戶不得爲下列目的使用或容許其他人士使用任何市場數據：(a)利用市場數據爲基礎或摘取市場數據以創建數據産品；(b) 厘定或訂定任何價格（包括任何結算價格），包括爲衍生工具合約、衍生工具合約的期權或在交易所以外的任何交易所上買賣的類似衍生工具厘定或訂定任何價格；及(c)將在外部發布、公布或以其他方式使用該等市場數據的任何其他摘取數據工作。訂閱用戶將受任何交易所不時可能就該等用途指定的任何其他限制約束。訂閱用戶將竭盡所能確保其合夥人、行政人員、董事、雇員及代理維持唯一控制及實際上管有及獨自可透過訂閱用戶管有的裝置存取市場數據。</br></br>
    (iii)儘管有上文第3b(i)及(ii)節所述，訂閱用戶可在其日常業務過程中偶爾向其各名客戶及分行辦事處提供數量被限制于足以讓訂閱用戶能够經營其業務所需的市場數據、或獲允許的少量市場數據，惟該等市場數據須幷不包括任何場外交易市場數據。該等轉發市場數據必須嚴格限制于通過電話通訊方式，當中不得使用電腦化的語音合成或任何其他科技，幷且必須與訂閱用戶或任何其他接收數據的人士的交易活動有關。訂閱用戶必須告知任何該等接收數據的人士該等數據屬專有及保密資料，不得向其他人士或實體披露或發放。訂閱用戶同意盡一切合理所能確保該等接收數據的人士受協議的條文約束。</br></br>
    c. 倘經銷商已同意允許訂閱用戶透過經銷商提供的裝置，例如非經銷商所能控制的行情資訊源（data feed）以外的方式收取、存取或展示市場數據，訂閱用戶將竭盡所能確保可使用其他裝置、附件或器材，以讓第三方可以在不受訂閱用戶在上文第3b 節下的報告責任約束下存取市場數據。</br></br>
    4. 報告</br></br>
    訂閱用戶同意盡速向經銷商提供交易所要求或需要及合理地與訂閱用戶收取市場數據有關的任何資料或報告（如適用）。訂閱用戶進一步同意盡速向經銷商提供第 3a 節所指經銷商與訂閱用戶之間協議須提供與訂閱用戶收取市場數據有關的任何額外資料或報告。</br></br>
    5. 查閱及審核的權利</br></br>
    a. 任何交易所指定的任何人士可于正常辦公時間內親到訂閱用戶的辦事處或地點，以觀察市場數據的編制以及審查和查閱任何裝置、附件或器材以及訂閱用戶根據第3b 和4 節須就其收取和使用市場數據而存置任何賬册與記錄。</br></br>
    b. 如審計中發現訂閱用戶少報對市場數據的使用量，訂閱用戶將即時作出調整（包括以月息 1½厘計算的利息），以補償經銷商及交易所。此外，按任何該交易所的選擇，訂閱用戶將須爲該交易所負擔發現差异的任何審計工作所産生的合理費用，金額按實際應付該交易所的費用的百分之五（5%）或以上計算。</br></br>
    c. 訂閱用戶須于有關記錄所相關的期間後三（3）年存置其向 CME、CBOT、COMEX 及 NYMEX 報告市場數據時所依據的記錄及賬册。訂閱用戶須于有關記錄所相關的期間後六（6）年存置其向 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S.及 Eurex 報告市場數據時所依據的記錄及帳目。倘訂閱用戶未能如上文規定存置該等記錄及帳目，訂閱用戶同意向各交易所支付根據任何有關的審計發現任何差异所招致的合理估計費用。</br></br>
    6. 市場數據費用</br></br>
    訂閱用戶將根據交易所不時公布當時適用的費率表（包括任何及所有適用的聯邦、州份或當地稅項），爲及代表各交易所（視乎適用而定）向經銷商支付（除非經銷商根據本協議承擔訂閱用戶的付款責任）收取市場數據的權利的應付費用。各交易所的費用可由各交易所不時作出更改，而毋須事先通知訂閱用戶。</br></br>
    7. 訂閱用戶的契諾、聲明及保證.</br></br>
    a. 訂閱用戶契諾、聲明及保證，其將不會從事分發市場數據的業務，同時，據其作出合理查詢後所知，其乃根據本協議下的授權收取市場數據。</br></br>
    b. 訂閱用戶同意其將不會使用或允許任何其他人士使用市場數據作任何不合法用途。</br></br>
    c. 訂閱用戶同意其將不會以任何方式使用市場數據以與交易所或經銷商競爭，或以任何方式使用市場數據以協助或讓第三方與交易所或經銷商競爭。</br></br>
    d. 訂閱用戶同意，根據本協議提供市場數據須受限于訂閱用戶嚴格遵守協議的條款，而經銷商或交易所繼而可（在發出或不發出通知及有或沒有理由下）在其判斷訂閱用戶有任何違反或不遵守本協議的條文下終止上述服務。</br></br>
    e. 訂閱用戶進一步聲明及保證(i)其擁有所有必要權力及授權執行及履行協議；(ii)協議爲合法、有效、具約束力及可對訂閱用戶强制執行；(iii)訂閱用戶執行或履行協議概無違反對訂閱用戶或交易所具約束力或適用的任何法律、規則、規例或命令或任何協議、文件或文據；及(iv)訂閱用戶存取及使用市場數據將根據所有適用聯邦、州份、當地法律、規例及條約行事。</br></br>
    8. 保證的免責聲明</br></br>
    市場數據將（及訂閱用戶同意市場數據將）按「原來狀况」、「可提供的况」基準提供，不附帶任何種類的保證。訂閱用戶同意：經銷商及其聯屬人士；交易所及其聯屬人士；以及其各自的任何成員、董事、行政人員、雇員或代理，以及交易所的任何授權人，概不就市場數據或其傳送、時間性、準確性或完整性，作出任何明示或暗示的聲明或保證，包括但不限于對其用于某一特定用途的可銷性、質量或合適性或其未被侵權（以及該等因法規或法律上或因任何買賣過程中或商業使用過程中産生者），作出任何暗示性的保證或任何保證。</br></br>
    9. 責任及損害賠償的範圍</br></br>
    a. 訂閱用戶同意：經銷商及其聯屬人士；交易所及其聯屬人士；以及其各自的任何成員、董事、行政人員、雇員或代理及交易所的任何授權人：</br></br>
    (i) 幷不擔保市場數據的順序、準確性或完整性，彼等任何一方亦概不就市場數據或其傳送過程中的任何延誤、不準確、出錯或遺漏，或就因訂閱用戶收取或使用市場數據而招致的任何損害，對訂閱用戶或任何其他人士負責，不論是否因彼等本身的疏忽、不可抗力事件或任可其他原因導致。</br></br>
    (ii) 概不就因協議及市場數據而産生或與之有關的任何（直接、間接或因之而起的）損失、責任或其他損害，對訂閱用戶或任何其他人士或實體負任何責任，包括但不限于：</br></br>
    (a) 地點或市場數據的任何不準確或不完整或其延遲、受到干擾、出錯或遺漏；或</br></br>
    (b) 訂閱用戶、其客戶或任何其他實體或其各自的任何聯屬人士、董事、行政人員、雇員或代理所 作或不作的任何决定或行動。</br></br>
    (c) 損失業務收入、損失利潤或任何懲罰性、間接、相應的、特別或類似的損害，不論任何性質、是否根據已訂合約、在侵權法下或其他，即使已獲告知産生該等損害的可能性。</br></br>
    b. 訂閱用戶明確表示明白，經銷商、交易所及其聯屬人士幷無就協議及市場數據，向訂閱用戶或任何第三方作出任何保證（明示或暗示的），包括但不限于：(i)就市場數據用于特定用途的時間性、順序、準確性、完整性、及時性、可銷性、質量或合適性作任何保證；或(ii)就訂閱用戶或任何第三方使用市場數據所得的效果作任何保證。</br></br>
    c. 如上文的免責聲明及責任豁免聲明或其任何部分被視爲無效或失效，經銷商、交易所及其各自的聯屬人士、董事、行政人員、成員、雇員及代理的累計責任，將不會超過實際的損失或損害金額或合計五十元（50.0美元），以較低者爲准。</br></br>
    10. 年期及終止</br></br>
    在訂閱用戶嚴格遵守本協議的條文的前提下，任何交易所在本協議下提供市場數據將于訂閱用戶與經銷商之間的協議及其任何續約年期內一直維持有效。此外，根據協議，本協議第 2a 及 2b 節所載的條文將于直至本協議終止爲止一直生效。</br></br>
    11. 彌償</br></br>
    訂閱用戶將就因或由于協議而産生或招致的任何及全部索償，向經銷商及交易所以及其各自的聯屬人士、董事、行政人員、雇員及代理作出彌償保證、爲其作出抗辯及使其免于因此而受到損害，包括但不限于因訂閱用戶根據本協議須存置的任何報告或記錄的任何不準確或遺漏或訂閱用戶未能提供或存置或訂閱用戶延遲提供或存置該等報告或記錄所導致的責任、損失或損害（包括但不限于律師費及其他開支）。</br></br>
    12. 其他事項</br></br>
    a. 因 CME、CBOT、COMEX 及 NYMEX 之間的協議所産生的任何訴訟須受伊利諾州的內部法規（及非利益衝突法）監管及按其詮釋。訂約各方願受伊利諾州庫克縣當地的州及聯邦法院的專屬司法管轄權管轄。因 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S 及訂閱用戶之間的本協議而産生的任何訴訟須受紐約州的內部法律（及非利益衝突法）監管及按其詮釋。</br></br>
    b. 在未經交易所的事先書面同意前（如適用），訂閱用戶不得將協議的全部或任何部分轉授。</br></br>
    c. 訂閱用戶不得修改或修訂協議的條款。</br></br>
    d. 倘協議的條款及條件與關于訂閱用戶收取及使用市場數據的任何其他協議之間有任何衝突，當以協議的條款及條件爲准。如因任何原因協議的一項或以上條文或其部分變得無效，協議的條文或其他部分將一直維持具十足效力及有效。</br></br>
    聲明 </br>
    閣下承認上述條款，即同意以下爲真確：</br>
    (1)閣下聲明有實際權限代訂閱者訂立本協議；</br>
    (2)閣下已閱讀上述條款；</br>
    (3)閣下理解上述條款；</br>
    (4)上述條款將構成任何適用法例或規例所定「文本」；及</br>
    (5)閣下同意遵守本協議上述所有條款</br></br>
    本人已閱讀理解幷同意遵守本協議上述所有條款
    `
  },
  featureTerms: {
    title: '環球期貨市場數據訂閱協議',
    subTitle: '本人已閱讀理解並同意遵守本協議上述所有條款。 ',
    item: `條款及條件與聲明</br></br>
    1. 投資於金融市場具一定風險，投資價格可升可跌。 </br></br>
    2. 客戶若欲終止以上計劃，須於一個月前以書面通知本公司，否則使用期不足一個月者，亦須繳付整月服務費用。 </br></br>
    3. 艾德證券期貨有限公司保留日後更改以上計劃及服務之權利及收費，恕不另行通知。 </br></br>
    4. 客戶確認清楚明白及同意下述附錄II: 市場數據訂閱協議。 </br></br>
    5. 各參與證券交易所或協會宣稱其向發布有關數據各方所提供之一切市場數據擁有專有權益。客戶 明白，概無一方擔保市場數據或任何其他市場資料之及時性、先後次序、準確性或完整性。因艾德證券期貨有限公司或任何發布數據一方之任何疏忽行動、不可抗力事件或任何發布數據一方不能合理控制之其他原因而造成之數據、資料、訊息或其傳送或交付而出現之偏差、錯誤、延誤、遺漏或乾擾，艾德證券期貨有限公司或任何發布數據一方均無須負責。 </br></br>
    6. 艾德證券期貨有限公司，芝加哥商品交易所及相關交易所竭力提供準確而可靠的資料，但並不保證資料絕對無誤。以上公司等概不負責任何資料錯漏、資料傳送時差或任何因依賴有關服務導致客戶獲取之實時報價而蒙受之損失。 </br></br>
    7. 客戶確認所有實時報價服務僅供個人使用，不得因任何理由而將任何數據提供予其他人士。 </br></br>
    8. 月費將於客戶之期貨賬戶內扣除。 </br></br>
    9. 客戶必須同意本公司將有關資料提交予服務供應商或任何相關之第三方作為身份核實之用。 </br></br>
    10. 客戶必須確保期貨戶口內須有足夠美金以扣除報價月費。艾德證券期貨有限公司有權收取客戶因戶口負數衍生之利息。 </br></br>

    <h3 style='text-align:center'>附錄 I: 非金融專業人士自我認證</h3></br></br>

    根據用戶的資格，用戶可能會被收取較低的資訊費用。被認定為“非專業”的用戶，才可以獲得收取較低的用戶費用。 </br></br>
    非專業是指並包括任何（i）個人及自然人用戶，或者（ii）某些小型企業實體（有限責任公司，合夥企業，信託或公司），收取和使用資訊（不包括任何場內交易數據） ，在每種情況下受到以下限制：</br></br>
    非專業用戶必須:</br></br>
    1) 有一個活躍的期貨交易賬戶;</br></br>
    2) 是個人，自然人或小型企業實體;</br></br>
    非專業用戶不得:</br></br>
    3) 成為任何交易所會員（或持有或租借任何類型的會員資格）;</br></br>
    4) 註冊或有資格作為任何股票，商品或期貨交易所或合約市場，或與任何金融監管當局一個專業的交易者或投資顧問的資格;</br></br>
    5) 從事券商，銀行，投資或金融活動的機構的代表;</br></br>
    非專業用戶使用資訊必須:</br></br>
    6) 是專為用戶的個人或私人使用;</br></br>
    7) 僅限於管理用戶的自有資產，而不是以任何身份與任何第三方的任何資產的管理連接使用;</br></br>
    非專業用戶獲取資料必須只能:</br></br>
    8) 就每一發布商（數據）通過最多兩部已被獲准取得實時數據和能夠送出交易指令至 CME Globex 平台的交易終端。 </br></br>
    不符合非專業用戶資格的用戶，將被認為是專業用戶。 </br></br>
    即使在本合同中的任何條款下，CME 有權在所有情況下作出最終決定，用戶是否作為一個非專業或專業用戶的定義。 CME 保留在任何時間修改本政策或終止非專業用戶較低的費用權利。 </br></br>
    有資格作為非專業用戶應該同意及確認其非專業用戶身份並遞交自我認證聲明回發布商。請注意，本聲明可能會受到發行商的審查和認可。若用戶不再具有作為一個非專業用戶的資格，用戶必須在合理可行的情況下，盡快通知發布商。 </br></br></br></br>


    <h3 style='text-align:center'>附錄 II: 市場數據訂閱協議</h3></br></br>

    本市場數據訂閱協議（「協議」）於申請提交當天（「生效日期」）由艾德證券期貨有限公司與閣下訂立。本協議准許閣下根據本協議的以下條款及條件存取、收取及使用若干市場數據（定義見下文）。協議監管閣下獲取及使用市場數據，並構成經銷商與訂閱用戶（各自為經銷商及訂閱用戶，各自為一「訂約方」，及統稱為「訂約方」）之間具法律約束力的協議。 </br></br>
    1. 釋義</br>
    a. 「裝置」指以可閱讀、可收聽或其他可理解的形式收取、存取或展示市場數據任何設備（固定或可攜式）單位。 </br></br>
    b. 「交易所」指包括但不限於CME（芝加哥商業交易所）、CBOT（芝加哥期貨交易所）、COMEX（紐約商品交易所）、NYMEX（紐約商業交易所）、ICE Futures Canada（ICE 加拿大期貨交易所）、ICE Futures、 Europe（ICE 歐洲期貨交易所）及ICE Futures US （ICE 美國洲際期貨交易所）。 </br></br>
    c. 「不可抗力事件」指任何水災、特殊天氣狀況、地震或其他天災、火災、戰爭、恐布活動、叛亂、騷亂、勞資糾紛、意外、政府行動、通訊或電力故障，或設備或軟件故障。 </br></br>
    d. 「人士」指任何自然人、獨自經營業務、法團、合夥經營業務、有限責任公司或其他機構。 </br></br>
    e. 「市場數據」指已上市及場外買賣的衍生工具合約（包括但不限於掉期及期貨）及期權合約或類似的衍生工具的資料及數據以及指數數據和分析數據。市場數據可包括但不限於開市及收市價、價格高位及低位、結算價、現時買入及賣出價、未平倉合約資料、最後賣價、限價、報價要求、固定價格、數據曲線、估計及實際交易量數據、合約規格，以及最新或延遲訊息。就訂閱用戶在協議下的責任而言，市場數據亦包括向訂閱用戶傳送與市場數據大致相若的資料的該等資料、數據及村料。 </br></br>
    f. 「買賣合約」指在上文所列的交易所買賣的合約及由交易所刊發的任何相應指數。 </br></br>
    g. 「場外交易市場數據」指與場外交易衍生工具合約有關的市場數據。 </br></br>

    2. 於市場數據的專有權利</br></br>
    a. 訂閱用戶表示明白及同意各交易所於及對其本身的市場數據享有專有及有價的財產權利。該等未在公開領域內出現的市場數據構成交易所享有的有價保密資料、商業秘密及/或所有權權利，並且該等市場數據最少於直至各相關交易所將之放在公開領域或授權將其各自的市場數據放在公開領域為止將一直為各交易所的有價保密資料、商業秘密及/或專屬所有權權利，如非訂立本協議，訂閱用戶將無權利或不可存取該等市場數據。某一交易所是否有將其市場數據放在公開領域或授權將其市場數據公開領域，將根據該交易所與經銷商之間訂立的協議的條款釐定，該協議的描述載於第 3a 節。 </br></br>
    b. 訂閱用戶表示明白及同意披露任何市場數據或任何違反或威脅違反本協議內所載的任何其他契諾或協定，將對交易所造成無法修補的傷害，金錢上的損害賠償將不足以補償。因此，訂閱用戶進一步表示明白及同意交易所將有權在現時可能享有的任何其他法律或衡平法補救以外（及不限於現時可能享有的任何其他法律或衡平法補救），就違反或威脅違反協議的任何條文、要求或契諾（包括但不限於任何披露或威脅披露市場數據）享有特定的履約及禁制命令及其他衡平法濟助。 </br></br>

    3. 訂閱用戶收取市場數據</br></br>
    a. 協議載列訂閱用戶可使用市場數據的條款及條件。訂閱用戶表示明白，儘管有任何協議，各交易所可按其酌情權，停止發放市場數據或更改或取消其本身的方法、速度或訊息特點。此外，訂閱用戶表示明白及同意，經銷商或交易所保留權利，可因任何理由或在沒有理由下不批准任何訂閱用戶及終止任何訂閱用戶收取市場數據， 而在該情況下，交易所將知會經銷商，而經銷商將在實際可行的情況下盡快停止向訂閱用戶提供市場數據。 </br></br>
    b. (i)除下文第3b(iii)節列明者外，訂閱用戶將只會以市場數據用於本身的內部業務活動（ 內部業務活動將不包括附屬公司及聯屬公司），及將只會在訂閱用戶不時以書面形式向經銷商指明的該等辦事處以及地點和裝置上使用。 （在緊接本文的前段內所用的「用於本身的內部業務活動」一詞，指用於訂閱用戶的(a)交易，以其本身的名義或為其客戶本身的名義；(b)評估，為其本身的內部業務決定；或(c)向客戶提供有關衍生工具市場的動向或趨勢的意見，但須受本分節下文有關以電話方式向客戶披露必要的市場數據及獲允許的市場數據的所有限制所規限。</br></br>

          (ii)訂閱用戶同意，除上文指定者外，其將不會以任何形式提供或以其他方式協助提供或容許提供市場數據或容許以其他方式協助提供市場數據予任何其他人士或任何辦事處或地點，亦不會容許任何其他人士直接或間接從該等辦事處或地點獲取任何市場數據，並將會採取及執行任何政策以合理防止市場數據該等辦事處或地點被取走。訂閱用戶特別地同意，在不限製或改變其於協議的第7 節或其他章節下的責任前提下，訂閱用戶不得為下列目的使用或容許其他人士使用任何市場數據：(a)利用市場數據為基礎或摘取市場數據以創建數據產品；(b) 釐定或訂定任何價格（包括任何結算價格），包括為衍生工具合約、衍生工具合約的期權或在交易所以外的任何交易所上買賣的類似衍生工具釐定或訂定任何價格；及(c)將在外部發布、公佈或以其他方式使用該等市場數據的任何其他摘取數據工作。訂閱用戶將受任何交易所不時可能就該等用途指定的任何其他限制約束。訂閱用戶將竭盡所能確保其合夥人、行政人員、董事、僱員及代理維持唯一控制及實際上管有及獨自可透過訂閱用戶管有的裝置存取市場數據。 </br></br>

          (iii)儘管有上文第3b(i)及(ii)節所述，訂閱用戶可在其日常業務過程中偶爾向其各名客戶及分行辦事處提供數量被限制於足以讓訂閱用戶能夠經營其業務所需的市場數據、或獲允許的少量市場數據，惟該等市場數據須並不包括任何場外交易市場數據。該等轉發市場數據必須嚴格限制於通過電話通訊方式，當中不得使用電腦化的語音合成或任何其他科技，並且必須與訂閱用戶或任何其他接收數據的人士的交易活動有關。訂閱用戶必須告知任何該等接收數據的人士該等數據屬專有及保密資料，不得向其他人士或實體披露或發放。訂閱用戶同意盡一切合理所能確保該等接收數據的人士受協議的條文約束。 </br></br>
    c. 倘經銷商已同意允許訂閱用戶透過經銷商提供的裝置，例如非經銷商所能控制的行情資訊源（data feed）以外的方式收取、存取或展示市場數據，訂閱用戶將竭盡所能確保可使用其他裝置、附件或器材，以讓第三方可以在不受訂閱用戶在上文第3b 節下的報告責任約束下存取市場數據。 </br></br>
    4. 報告</br></br>
    訂閱用戶同意儘速向經銷商提供交易所要求或需要及合理地與訂閱用戶收取市場數據有關的任何資料或報告（如適用）。訂閱用戶進一步同意儘速向經銷商提供第 3a 節所指經銷商與訂閱用戶之間協定須提供與訂閱用戶收取市場數據有關的任何額外資料或報告。 </br></br>
    5. 查閱及審核的權利</br></br>
    a. 任何交易所指定的任何人士可於正常辦公時間內親到訂閱用戶的辦事處或地點，以觀察市場數據的編制以及審查和查閱任何裝置、附件或器材以及訂閱用戶根據第3b 和4 節須就其收取和使用市場數據而存置任何賬冊與記錄。 </br></br>
    b. 如審計中發現訂閱用戶少報對市場數據的使用量，訂閱用戶將即時作出調整（包括以月息 1½厘計算的利息），以補償經銷商及交易所。此外，按任何該交易所的選擇，訂閱用戶將須為該交易所負擔發現差異的任何審計工作所產生的合理費用，金額按實際應付該交易所的費用的百分之五（5%）或以上計算。 </br></br>
    c. 訂閱用戶須於有關記錄所相關的期間後三（3）年存置其向 CME、CBOT、COMEX 及 NYMEX 報告市場數據時所依據的記錄及賬冊。訂閱用戶須於有關記錄所相關的期間後六（6）年存置其向 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S.及 Eurex 報告市場數據時所依據的記錄及賬目。倘訂閱用戶未能如上文規定存置該等記錄及賬目，訂閱用戶同意向各交易所支付根據任何有關的審計發現任何差異所招致的合理估計費用。 </br></br>
    6. 市場數據費用</br></br>
    訂閱用戶將根據交易所不時公佈當時適用的費率表（包括任何及所有適用的聯邦、州份或當地稅項），為及代表各交易所（視乎適用而定）向經銷商支付（除非經銷商根據本協議承擔訂閱用戶的付款責任）收取市場數據的權利的應付費用。各交易所的費用可由各交易所不時作出更改，而毋須事先通知訂閱用戶。 </br></br>
    7. 訂閱用戶的契諾、聲明及保證.</br></br>
    a. 訂閱用戶契諾、聲明及保證，其將不會從事分發市場數據的業務，同時，據其作出合理查詢後所知，其乃根據本協議下的授權收取市場數據。 </br></br>
    b. 訂閱用戶同意其將不會使用或允許任何其他人士使用市場數據作任何不合法用途。 </br></br>
    c. 訂閱用戶同意其將不會以任何方式使用市場數據以與交易所或經銷商競爭，或以任何方式使用市場數據以協助或讓第三方與交易所或經銷商競爭。 </br></br>
    d. 訂閱用戶同意，根據本協議提供市場數據須受限於訂閱用戶嚴格遵守協議的條款，而經銷商或交易所繼而可（在發出或不發出通知及有或沒有理由下）在其判斷訂閱用戶有任何違反或不遵守本協議的條文下終止上述服務。 </br></br>
    e. 訂閱用戶進一步聲明及保證(i)其擁有所有必要權力及授權執行及履行協議；(ii)協議為合法、有效、具約束力及可對訂閱用戶強制執行；(iii)訂閱用戶執行或履行協議概無違反對訂閱用戶或交易所具約束力或適用的任何法律、規則、規例或命令或任何協議、檔或文據；及(iv)訂閱用戶存取及使用市場數據將根據所有適用聯邦、州份、當地法律、規例及條約行事。 </br></br>

    8. 保證的免責聲明</br></br>
    市場數據將（及訂閱用戶同意市場數據將）按「原來狀況」、「可提供的況」基準提供，不附帶任何種類的保證。訂閱用戶同意：經銷商及其聯屬人士；交易所及其聯屬人士；以及其各自的任何成員、董事、行政人員、僱員或代理，以及交易所的任何授權人，概不就市場數據或其傳送、時間性、準確性或完整性，作出任何明示或暗示的聲明或保證，包括但不限於對其用於某一特定用途的可銷性、質量或合適性或其未被侵權（以及該等因法規或法律上或因任何買賣過程中或商業使用過程中產生者），作出任何暗示性的保證或任何保證。 </br></br>
    9. 責任及損害賠償的範圍</br></br>
    a. 訂閱用戶同意：經銷商及其聯屬人士；交易所及其聯屬人士；以及其各自的任何成員、董事、行政人員、僱員或代理及交易所的任何授權人：</br></br>
    (i) 並不擔保市場數據的順序、準確性或完整性，彼等任何一方亦概不就市場數據或其傳送過程中的任何延誤、不准確、出錯或遺漏，或就因訂閱用戶收取或使用市場數據而招致的任何損害，對訂閱用戶或任何其他人士負責，不論是否因彼等本身的疏忽、不可抗力事件或任可其他原因導致。 </br></br>
    (ii) 概不就因協議及市場數據而產生或與之有關的任何（直接、間接或因之而起的）損失、責任或其他損害，對訂閱用戶或任何其他人士或實體負任何責任，包括但不限於：</br></br>
    (a) 地點或市場數據的任何不准確或不完整或其延遲、受到干擾、出錯或遺漏；或</br></br>
    (b) 訂閱用戶、其客戶或任何其他實體或其各自的任何联屬人士、董事、行政人員、僱員或代理所 作或不作的任何決定或行動。 </br></br>
    (c) 損失業務收入、損失利潤或任何懲罰性、間接、相應的、特別或類似的損害，不論任何性質、是否根據已訂合約、在侵權法下或其他，即使已獲告知產生該等損害的可能性。 </br></br>
                  b. 訂閱用戶明確表示明白，經銷商、交易所及其聯屬人士並無就協議及市場數據，向訂閱用戶或任何第三方作出任何保證（明示或暗示的），包括但不限於：(i)就市場數據用於特定用途的時間性、順序、準確性、完整性、及時性、可銷性、質量或合適性作任何保證；或(ii)就訂閱用戶或任何第三方使用市場數據所得的效果作任何保證。 </br></br>
    c. 如上文的免責聲明及責任豁免聲明或其任何部分被視為無效或失效，經銷商、交易所及其各自的聯屬人士、董事、行政人員、成員、僱員及代理的累計責任，將不會超過實際的損失或損害金額或合計五十元（50.0美元），以較低者為準。 </br></br>
    10. 年期及終止</br></br>
        在訂閱用戶嚴格遵守本協議的條文的前提下，任何交易所在本協議下提供市場數據將於訂閱用戶與經銷商之間的協議及其任何續約年期內一直維持有效。此外，根據協定，本協議第 2a 及 2b 節所載的條文將於直至本協議終止為止一直生效。 </br></br>
    11. 彌償</br></br>
    訂閱用戶將就因或由於協議而產生或招致的任何及全部索償，向經銷商及交易所以及其各自的聯屬人士、董事、行政人員、僱員及代理作出彌償保證、為其作出抗辯及使其免於因此而受到損害，包括但不限於因訂閱用戶根據本協議須存置的任何報告或記錄的任何不准確或遺漏或訂閱用戶未能提供或存置或訂閱用戶延遲提供或存置該等報告或記錄所導致的責任、損失或損害（包括但不限於律師費及其他開支）。 </br></br>
    12. 其他事項</br></br>
    a. 因 CME、CBOT、COMEX 及 NYMEX 之間的協議所產生的任何訴訟須受伊利諾州的內部法規（及非利益衝突法）監管及按其詮釋。訂約各方願受伊利諾州庫克縣當地的州及聯邦法院的專屬司法管轄權管轄。因 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S 及訂閱用戶之間的本協議而產生的任何訴訟須受紐約州的內部法律（及非利益衝突法）監管及按其詮釋。 </br></br>
    b. 在未經交易所的事先書面同意前（如適用），訂閱用戶不得將協議的全部或任何部分轉授。 </br></br>
    c. 訂閱用戶不得修改或修訂協議的條款。 </br></br>
    d. 倘協議的條款及條件與關於訂閱用戶收取及使用市場數據的任何其他協議之間有任何衝突，當以協議的條款及條件為準。如因任何原因協議的一項或以上條文或其部分變得無效，協議的條文或其他部分將一直維持具十足效力及有效。</br></br>
    聲明 </br>
    閣下承認上述條款，即同意以下爲真確：</br>
    (1)閣下聲明有實際權限代訂閱者訂立本協議；</br>
    (2)閣下已閱讀上述條款；</br>
    (3)閣下理解上述條款；</br>
    (4)上述條款將構成任何適用法例或規例所定「文本」；及</br>
    (5)閣下同意遵守本協議上述所有條款</br>
    `

  },
  stockterms: {
    // 港股,美股
      title: '港股/美股實時行情條款及條件與聲明',
      subTitle: '客戶確認清楚明白及簽署以同意下述有關申請網上實時報價服務之條款及細則，以及下列陳述:',
      item: `1.費用將於申請審批後即時扣除當月費用；其後於每月25日扣除下個月的費用。 </br>
        2.客戶必須確保證券戶口內須有足夠資金餘額以扣除報價月費。本公司有權收取客戶因戶口負數衍生之利息。 </br>
        3.為免引起任何誤解, 服務不足一個月亦作一個月計算。 </br>
        4.客戶如若欲終止以上計劃，請於每月自動續期扣費前(即每月的第25日前)提出。</br>
        5.客戶確認所有實時報價服務僅供個人使用，不得因任何理由而將任何數據提供予其他人士。 </br>
        6.客戶必須同意本公司將有關資料提交予服務供應商或任何相關之第三方作為身份核實之用。 </br>
        7.本公司及相關機構竭力提供準確而可靠的資料，但並不保證資料絕對無誤。以上公司等概不負責任何資料錯漏、資料傳送時差或任何因依賴有關服務導致客戶獲取之實時報價而蒙受之損失。 </br>
        8.各參與證券交易所或協會宣稱其向發布有關數據各方所提供之一切市場數據擁有專有權益。客戶明白，概無一方擔保市場數據或任何其他市場資料之及時性、先後次序、準確性或完整性。因艾德或任何發布數據一方之任何疏忽行動、不可抗力事件或任何發布數據一方不能合理控制之其他原因而造成之數據、資料、訊息或其傳送或交付而出現之偏差、錯誤、延誤、遺漏或干擾，艾德或任何發布數據一方均無須負責。 </br>
        9.艾德保留日後更改以上計劃及服務之權利及收費，恕不另行通知。 </br>
        10.投資於金融市場具一定風險，投資價格可升可跌。 `
  },
  conditionDialogTitle: '申請行情須知',
  ineligibleDialogTitle: '未符合條件申請',
  ineligibleTipContent: '很抱歉,由於您未在2019年6月1日後成功存入資金,暫不支持申請',
  consentRules: '本人確認清楚明白及簽署以上同意上述有關申請網上及時報價服務之條款及細則,以及陳述.',
  submitApply: '確認申請',
  selectQuotesErr: '請選擇申請類型',
  applyContentType: {
    'EDDID_FAMILY_BUCKET_MARKET_FREE': '艾德一站通行情-免費',
    'JIELI_GLOBAL_HK_STOCKS_MARKET': '捷利環球港股行情',
    'JIELI_GLOBAL_US_STOCKS_MARKET': '捷利美股行情',
    'EDDID_FAMILY_BUCKET_MARKET': '艾德一站通行情',
    'HK_STOCKS_REAL_TIME_MARKET_FREE': '港股實時行情-免費',
    'HK_STOCKS_REAL_TIME_MARKET': '港股實時行情',
    'US_STOCKS_REAL_TIME_MARKET': '美股實時行情',
    'FUTURES_REAL_TIME_MARKET': '期貨實時行情',

    'eddid_family_bucket_market_free': '艾德一站通行情-免費',
    'jieli_global_hk_stocks_market': '捷利環球港股行情',
    'jieli_global_us_stocks_market': '捷利美股行情',
    'eddid_family_bucket_market': '艾德一站通行情',
    'hk_stocks_real_time_market_free': '港股實時行情-免費',
    'hk_stocks_real_time_market': '港股實時行情',
    'us_stocks_real_time_market': '美股實時行情',
    'futures_real_time_market': '期貨實時行情'
  },
  status: {
    submitted: '審核中',
    processing: '審核中',
    reject: '失敗',
    completed: '已開通',
    notOpen: '未開通',
    SUBMITTED: '審核中',
    PROCESSING: '審核中',
    COMPLETED: '已開通',
    REJECT: '失敗',
    IMMEDIATE_APPLY: '立即申請',
    CANCLED: '已取消'
  },
  buttonStatus: {
    IMMEDIATE_APPLY: '立即申請',
    COMPLETED: '取消訂閱',
    NO_BUTTON: '審核中'
  },
  NEW: '開通',
  RENEW: '續訂',
  CANCEL: '取消',
  noQuotes: '無行情申請記錄',
  confirm: '確 定',
  cancel: '取 消',
  cancelSuccess: '已退訂',
  hasUsed: '前有效',
  submitText: '立即申請',
  unit: '/月',
  timeUnit: {
    'DAY': '日',
    'WEEK': '週',
    'MONTH': '月',
    'QUARTER': '季',
    'YEAR': '年'
  },
  isCanceled: '已退訂',
  conditionDataFirsttext: `1. 現有客戶可申請購買`,
  moneyText: '，費用為每月HKD {money}',
  conditionDatalasttext: `。 （客戶需確保交易賬戶中有足夠的現金餘額作每月扣款，才獲審批開通)。 </br>
    2. 費用將於申請審批後即時扣除當月費用；其後於每月25日扣除下個月的費用； </br>
    3. 費用計算方式</br>
    服務不足一個月亦作一個月計算。如：1月15日申請，當月只剩16天，不夠整月，亦按照整月收費。而在1月25日則會扣除整個2月的費用 - HKD `,
  feeContent: '免費',
  feeText: '前有效',
  notProfessionInfo: '（只適用於非金融專業人士申請）',
  stockNotMoneyInfo: '證券賬戶可用資金不足，請補充入金後重試',
  futuresNotMoneyInfo: '期貨賬戶可用資金不足，請補充入金後重試',
  mixNotMoneyInfo: '可用資金不足，請補充入金後重試',
  usErrorInfo: '請確認本人之所有資料與開戶時所提交的資料是否相同',
  fee: '費用明細',
  noAccountInfo: '您當前無狀態正常的交易賬戶，前往查看',
  goto: '前往',
  validityPeriod: '(臨時有效期)',
  enterChange: '請填寫已有更改的資料',
  eddidProConditiontext: `1.現有期貨客戶可申請使用{name}，此服務包括香港及環球期貨實時行情，服務費用為每月HKD$568（推廣期內優惠月費為{currency}\${price}）；</br>
  2.{name}所提供的實時行情服務可於Eddid One PC及手機應用程式（APP）使用</br>
  3.有關費用將於成功開通後即時扣除；其後於每月25日扣除下個月的費用；</br>
  4.閣下在{name}服務生效後，即表示授權艾德證券期貨根據上列價格每月自動續期，閣下須確保其期貨交易賬戶中有足夠的現金結餘作每月扣款之用，以免被暫停服務；</br>
  5.服務使用不足一個月費用亦作一個月計算。如：1月15日申請，當月只剩16天，不夠整月，亦會收取整月收費。而在1月25日後申請則會扣除1月及2月的費用。</br>`
}
